import styled from "styled-components";
import { Link } from "react-scroll";

export const StyledButton = styled(Link)`
  padding: 0.65rem 2.3rem;
  color: #fff;
  border-radius: 0.5rem;
  font-weight: 600;
  text-decoration: none;
  background-color: ${({ color }) => color};
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: #fff;
    background-color: ${({ color }) => color};
    box-shadow: 0px 10px 36px rgba(0, 0, 0, 0.15);
  }
  @media screen and (min-width: 768px) {
    padding: 0.75rem 2.5rem;
  }
`;

export const StyledSecButton = styled(Link)`
  padding: 0.60rem 2.3rem;
  color: ${({ color }) => color};
  border-radius: 0.5rem;
  font-weight: 600;
  text-decoration: none;
  background-color: #fff;
  border: 2px solid;
  border-color: ${({ color }) => color};
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: #fff;
    background-color: ${({ color }) => color};
    box-shadow: 0px 10px 36px rgba(0, 0, 0, 0.15);
  }
  margin-right: 1rem;
  @media screen and (min-width: 768px) {
    padding: 0.65rem 2.5rem;
  }
`;

export const Tittle = styled.p`
  font-weight: 700;
  font-size: 2rem;
  line-height: 150%;
  margin-bottom: 1.5rem;
  @media screen and (min-width: 768px) {
    font-size: 3.5rem;
    margin-bottom: 2.5rem;
  }
  @media only screen and (max-width: 548px) {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
`;

export const Color = styled.span`
  color: ${({ color }) => color};
`;

export const Left = styled.div`
  align-self: center;
  text-align: initial;
  margin-top: 4rem;
  @media screen and (min-width: 768px) {
    align-self: flex-end;
    padding-bottom: 2.5rem;
    width: 60%;
  }
  z-index: 100;
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
`;

export const Right = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  height: 700px;
  width: 400px;
  margin-top: 4rem;

  @media only screen and (max-width: 768px) {
    display: none;
  }

  @media screen and (min-width: 768px) {
    bottom: auto;
    margin-bottom: 1rem;
    img {
      border-radius: 50px;
    }
  }
  @media screen and (min-width: 1024px) {
    right: 10%;
  }
  @media screen and (min-width: 1542px) {
    right: 15%;
  }
`;

export const SocialIcon = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  z-index: 300;
  @media screen and (min-width: 768px) {
    padding-top: 0;
    padding-bottom: 2.5rem;
    flex-direction: row;
    align-self: center;
  }
`;

export const Url = styled.a`
  width: max-content;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  color: #000;
  svg{
    transition: .2s;
  }
  &:hover {
    color: #000;
    svg{
      transform: scale(1.2);
    }
  }
  @media screen and (min-width: 768px) {
    margin-bottom: 0;
    margin-right: 1.2rem;
  }
`;

export const Infosection = styled.section`
  row-gap: 1rem;
  display: grid;
  grid-template-row: 100%;
  grid-row-gap: 1.5rem;
  height: calc(100vh - 3rem);
  @media screen and (min-width: 768px) {
    grid-template-row: repeat(2, 1fr);
    align-items: center;
    text-align: initial;
    height: 100vh;
  }
  @media screen and(min-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
  }
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 1200px){
    max-width: 1140px;
  }
`;
